import clsx from "clsx";

import { View } from "../base";

export type RangeKey = "7d" | "30d" | "90d" | "all";

const RANGE_DAYS: Record<Exclude<RangeKey, "all">, number> = { "7d": 7, "30d": 30, "90d": 90 };

const OPTIONS: { key: RangeKey; label: string }[] = [
  { key: "7d", label: "7d" },
  { key: "30d", label: "30d" },
  { key: "90d", label: "90d" },
  { key: "all", label: "All" },
];

export function rangeToDates(r: RangeKey): { startDate?: string; endDate?: string } {
  if (r === "all") return { startDate: "2024-01-01T00:00:00.000Z" };
  return { startDate: new Date(Date.now() - RANGE_DAYS[r] * 24 * 60 * 60 * 1000).toISOString() };
}

type RangePickerProps = {
  value: RangeKey;
  onChange: (r: RangeKey) => void;
};

export const RangePicker = ({ value, onChange }: RangePickerProps) => (
  <View className="inline-flex overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
    {OPTIONS.map((option) => (
      // Segmented control — allowed raw-button exception per src/CLAUDE.md (no DS equivalent)
      <button
        key={option.key}
        type="button"
        onClick={() => onChange(option.key)}
        className={clsx(
          "px-3 py-1.5 text-xs font-medium transition-colors",
          value === option.key
            ? "bg-purple-600 text-white dark:bg-purple-500"
            : "bg-white text-gray-500 hover:bg-gray-50 dark:bg-slate-900 dark:text-gray-400 dark:hover:bg-gray-800",
        )}
      >
        {option.label}
      </button>
    ))}
  </View>
);
